import React from 'react';
import { AutocompleteTextInputField } from '../../../../../shared/form/inputs/AutocompleteTextInputField';
import { roomFieldName } from '../../quoteOrDesignFormFieldNameHelpers';
import { RoomAutocompleteItem, roomTypes } from '../roomTypes';

type Props = {
  unitIndex: number;
  manifoldIndex: number;
  roomIndex: number;
  handleSelectionOfRoomName: (selectedItem: RoomAutocompleteItem) => void;
};

export const RoomNameField = ({ unitIndex, manifoldIndex, roomIndex, handleSelectionOfRoomName }: Props) => (
  <>
    <AutocompleteTextInputField
      name={roomFieldName(unitIndex, manifoldIndex, roomIndex, 'name')}
      label="Room Name"
      autocompleteItems={roomTypes}
      onSelect={handleSelectionOfRoomName}
    />
  </>
);
